//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  computed: {
    link_styles() {
      return 'text-gray-50 px-4 text-sm transition duration-500 ease-in-out whitespace-nowrap  hover:text-primary text-center relative cursor-pointer'
    },
    headerItems() {
      const section = Array.isArray(this.$store.state.globals_new)
          ? this.$store.state.globals_new.find(obj => obj.handle === 'subheader')
          : null

      const items = Array.isArray(section?.items) ? section.items : []

      return items
          .filter(link => {
            if (!link.active) return false
            if (link.visibility === 'auth' && !this.user) return false
            return true
          })
          .slice()
          .sort((a, b) => (a.position ?? 0) - (b.position ?? 0))
    }

  },
  methods: {
    goTo(url) {
      return this.localePath(`/${url}`)
    },
    action(item) {
      if(!_.get(item, 'url') && _.get(item, 'action')) {
        this.openCashier(_.get(item, 'action'))
      }
    }
  }
}
